import { makeStyles } from '@material-ui/core';

export const getProposalEditorToolbarTemplatesSectionButtonStyles = makeStyles(
  () => ({
    loader: {
      position: 'absolute',
    },
  }),
);
